export const environment = {
  production: false,
  imports: [],
  api: {
    ibge: "https://servicodados.ibge.gov.br/api/v1/localidades/estados",
    mv: {
      nf: "https://dev-nf-mv.api-mv.com.br/v1",
      // nf: "http://localhost:3011/v1",
      obra: "https://dev-mod-obra.meuvidraceiro.com.br/api/vidraceiro_mv",
      // obra: "http://localhost:3064/vidraceiro_mv",
      zemt: "https://www.developera.meuvidraceiro.com.br/api"
    }
  },
  externals: {
    validadorTecnospeed: "https://validador.nfe.tecnospeed.com.br/",
    cnpjLookup: "https://brasilapi.com.br/api/cnpj/v1"
  }
};
